// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2_ITy","header":"PatientBlock_header__2EZoW","label":"PatientBlock_label__2ZiL3","option":"PatientBlock_option__2ve1_"};